import api from './api';
import { ApiResponse, DataImportRun } from '../types';

export const anpService = {
  async getPrecosAtivo(): Promise<boolean> {
    const response = await api.get<ApiResponse<{ ativo: boolean }>>('/admin/imports/anp/precos/config');
    return response.data.data.ativo;
  },

  async setPrecosAtivo(ativo: boolean): Promise<boolean> {
    const response = await api.put<ApiResponse<{ ativo: boolean }>>('/admin/imports/anp/precos/config', null, {
      params: { ativo },
    });
    return response.data.data.ativo;
  },

  // Importações podem levar alguns minutos (download + geocodificação)
  async importPrecos(): Promise<DataImportRun> {
    const response = await api.post<ApiResponse<DataImportRun>>('/admin/imports/anp/precos', null, { timeout: 600000 });
    return response.data.data;
  },

  async importCadastro(): Promise<DataImportRun> {
    const response = await api.post<ApiResponse<DataImportRun>>('/admin/imports/anp/cadastro', null, { timeout: 600000 });
    return response.data.data;
  },

  async geocode(): Promise<DataImportRun> {
    const response = await api.post<ApiResponse<DataImportRun>>('/admin/imports/geocode', null, { timeout: 600000 });
    return response.data.data;
  },

  async recentRuns(limite = 20): Promise<DataImportRun[]> {
    const response = await api.get<ApiResponse<DataImportRun[]>>('/admin/imports', { params: { limite } });
    return response.data.data || [];
  },
};
